<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <orgsidebar></orgsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
            <div v-if="wtdata!==null" class="moduleCard">
               <wondertable :wtID="'orgAdmins'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'No organization administrators found'"
                            :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Organization Administrators'" :burgerMenu="burgermenu" ref="thisWT"></wondertable>
            </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
    <b-modal ref="addAdmin" title="Add Administrators" @ok="completeAdd()">
        <genericlist ref="addList" v-if="mitems!==null" :items="mitems" :displayType="'0'" :mode="''"></genericlist>
    </b-modal>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"
  import genericlist from "../../components/GenericList.vue"

  export default {
    name: 'OrgPrivileges',
    components: {acheader,acfooter,orgsidebar,wondertable,genericlist},
    data() {
      return {
        burgermenu: [[{
          html: "Add Administrator",
          value: "doAdd"
        }]],
        mitems:null,
        wids: ["OrganizationAdminID"],
        wtdata: null,
        wtmethods: {
          doAdd: { method: function(param, ref) {
            ref.doAdd(param);
          }, ref: this},
          doDelete: { method: function(param, ref) {
            ref.doDelete(param);
          }, ref: this}

        }
      }
    },
    methods: {
      completeAdd() {
  
        this.apiCommand([
            {
              Operation: "Organization",
              Function: "AddAdmin",
              Fields: {
                OrganizationID: this.$route.params.id,
                ClientID: this.$refs["addList"].getResult()
              }
            }
        ]).then(r=>{

          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject == "OK") {
            this.popDialog(0, "Administrator added successfully");
            this.renderTable(true);
          }
          else {
            this.popDialog(1,cr.returnObjects[0].returnObject);
          }
        });

      },
      doAdd(param) {
        this.apiCommand([
         {
           Operation: "Organization",
           Function: "GetAllClients",
           Fields: {
             OrganizationID: this.$route.params.id
           }
         }      
        ]).then(response=>{
          try {

            var its=JSON.parse(JSON.parse(response.CommandResult).returnObjects[0].returnObject);
            this.mitems=[];
            for(var it of its) {
              this.mitems.push({
                text: this.buildSimUser(it.ClientID, it.Username, it.EmailAddress, it.FirstName, it.LastName, false, false),
                value: it.ClientID
              })
            }

            this.$refs['addAdmin'].show();
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }

        }) 
      },
      doDelete(param) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this administrator?', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
             {
               Operation: "Organization",
               Function: "DeleteAdmin",
               Fields: {
                 OrganizationAdminID: param.OrganizationAdminID
               }
             }
            ]).then(r=>{

              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject == "OK") {
                this.popDialog(0, "Administrator removed successfully");
                this.renderTable(true);
              }
              else {
                this.popDialog(1,cr.returnObjects[0].returnObject);
              }
            });
          }
        
        })
  
      },
      renderTable(refreshWT) {
        this.apiCommand([
          {
             Operation: "Organization",
             Function: "GetAdmins",
             Fields: {
               OrganizationID: this.$route.params.id
             }
          }      
        ]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            this.wtdata = JSON.parse(cr.returnObjects[0].returnObject);

            if (refreshWT) {
              this.$refs["thisWT"].renderTable(this.wtdata);
            }
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }

        })
      }
    },
    mounted() {     
      this.doPage().then(r=>{
        this.bootstrapOrg(this.$route.params.id);
        this.renderTable(false);
      });
    }
  }
</script>
